import { isNull, isNumber } from "lodash";

export class PhoneNumFormatter {

    current: string;
    prev: string | null;
    erasing: boolean;
    maxLength: number;

    constructor() {
        this.current = "";
        this.prev = null;
        this.erasing = false;
        this.maxLength = 14;
    }

    setValue(val: string, character: string = ""): void {
        this.prev = this.current;
        this.current = val + character;

        if (this.prev.length > this.current.length){
            this.erasing = true;
        } else {
            this.erasing = false;
            const lastIsNumber = !isNaN(Number(val[val.length - 1]));

            if (!lastIsNumber && val.length != 4 && val.length != 5 && val.length != 10) {
                this.current = this.prev;
            }
        }

        if (this.current.length === this.maxLength) {
            this.prev = this.current;
        }
    }

    format(val: string): string {
        const formatted = val.replace(/[(^\s+)(^\-+)(^\(+)(^\)+)]/g, "");
        const phoneIsNumber = /^\d+$/.test(formatted);
        if (!phoneIsNumber && formatted !== "")
            return this.current;

        if (val.length <= this.maxLength) {
            this.setValue(val);
        } else {
            return this.prev;
        }

        if (!this.erasing) {
            if (this.current.length <= this.maxLength) {
                let newVal = val.replace(/\D/g, "");
                
                if (newVal.length === 3) {
                    newVal = '('+newVal.substring(0,3)+') '
                }
                else if (newVal.length < 4) {
                    newVal = '('+newVal;
                }
                else if (newVal.length >= 4 && newVal.length < 6) {
                    newVal = '('+newVal.substring(0,3)+') '+newVal.substring(3,6);
                }
                else if (newVal.length === 6) {
                    newVal = '('+newVal.substring(0,3)+') '+newVal.substring(3,6)+'-';
                }
                else if (newVal.length > 6) {
                    newVal = '('+newVal.substring(0,3)+') '+newVal.substring(3,6)+'-'+newVal.substring(6,10);
                }
                this.setValue(newVal);
            } else {
                this.setValue(this.prev);
            }
        } else {
            this.setValue(val);
        }

        return this.current;
    }
}